export default function() {
  return audience => {
    if (audience === undefined || audience.length == 0) return 'All';
    if (audience.constructor == Array) {
      if (audience.length < 2) {
        return audience.toString().toUpperCase();
      } else {
        let capitolAudience = audience.map(aud => {
          if (aud.toLowerCase() == 'lawyer') {
            return 'Lawyer';
          } else {
            return aud.toUpperCase();
          }
        });
        return capitolAudience.join('/');
      }
    } else if (audience.constructor == Object) {
      const result = [];
      Object.keys(audience).forEach(aud => {
        if (audience[aud] && aud !== '$$hashKey') {
          // eslint-disable-next-line no-unused-expressions
          aud.length <= 3 ? result.push(aud.toUpperCase()) : result.push('Lawyer');
        }
      });
      return result.length > 0 ? result.join('/') : 'All';
    } else {
      return audience;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/MultiAudience.js